<div class="h-full sm:flex items-center gap-3">
    <app-account-menu />
</div>
